import { Delete, ExpandMore } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, IconButton, TableCell, TableRow, TextField } from "@mui/material";
import { cloneDeep } from "lodash";
import { IComboBoxOption, IMaterial, MaterialContext } from "../../interfaces";
import { MaterialInputDialog } from "../MaterialInputDialog";
import { MaterialIdentifiers } from "../Shared/MaterialIdentifiers";
import { MaterialInfo } from "../Shared/MaterialInfo";


interface IMaterialTableRow {
    material: IMaterial,
    returnStatuses: IComboBoxOption[],
    onUpdate: (material: IMaterial, splitMaterial?: IMaterial) => void,
    onCopy?: () => void,
    readonly: boolean,
    onRemove: () => void,
    key: any
}

export const MaterialTableRow: React.FC<IMaterialTableRow> = ({
    material,
    returnStatuses,
    onUpdate,
    onCopy,
    readonly,
    onRemove,
    key
}) => {

    const handleChangeReturnStatus = (value: string | null) => {

        let currentMaterial = cloneDeep(material);
        currentMaterial.expectedReturnState = returnStatuses.filter(x => x.value === value)[0];
        onUpdate(currentMaterial);
    }

    const getActionColumnStyle = (statusId: number) => {

        return (statusId === 1 && !readonly) ? { width: '180px' } : {};
    }

    return (
        <TableRow className="material-row" key={key}>
            <TableCell>
                <Accordion elevation={0}>
                    <AccordionSummary
                        expandIcon={<ExpandMore />}
                    >
                        <div>
                            <p><strong>{material.l3}</strong></p>
                            <small>{material.l1?.value}</small>
                            <small>{material.l2?.value}</small>
                        </div>

                    </AccordionSummary>
                    <AccordionDetails>
                        <MaterialInfo material={material} />
                    </AccordionDetails>
                </Accordion>
            </TableCell>

            <TableCell>
                <p>{material.classes} </p>
            </TableCell>
            <TableCell>
                <p>{material.spareType?.value}</p>
            </TableCell>
            <TableCell>
                <MaterialIdentifiers material={material} />
            </TableCell>
            <TableCell>
                <p>{material.state?.value}</p>
            </TableCell>
            <TableCell>
                <p>
                    {material.quantity}
                    <span>({material.unitOfQuantity.value})</span>
                </p>
            </TableCell>

            <TableCell>

                {readonly ?
                    <span>{material.expectedReturnState?.value}</span>
                    :
                    <Autocomplete
                        id="material-status"
                        options={returnStatuses.map(x => x.value)}
                        value={material.expectedReturnState?.value || null}
                        onChange={(_, value) => handleChangeReturnStatus(value)}
                        readOnly={readonly}
                        renderInput={(params) => <TextField
                            {...params}
                            required
                            variant="standard"
                        />}
                    />
                }


            </TableCell>
            <TableCell sx={getActionColumnStyle(material.statusId ?? 0)}>


                {!readonly && <>
                    {material.statusId === 1 &&
                        <MaterialInputDialog
                            entity={{ id: "", type: "CONTRACT" }}
                            context={MaterialContext.MaterialRow}
                            onSubmitMaterial={(material, splitMaterial) => onUpdate(material, splitMaterial)}
                            onCopy={onCopy}
                            material={material}
                            focus={false}
                        />
                    }
                    <IconButton aria-label="remove material" onClick={onRemove}>
                        <Delete />
                    </IconButton>
                </>}
            </TableCell>
        </TableRow >
    );
}

